import { isBoolean } from 'lodash';
import { SHOW_THIRD_PARTY_MODAL, TARGET_URL } from './ThirdPartyModalActions';

const initialState = {
  showConsentModal: false,
  targetURL: null
};

export const thirdPartyModalReducer = (state = initialState, action) => {
  if (action.type === SHOW_THIRD_PARTY_MODAL) {
    const { showThirdPartyModal } = action;
    if (isBoolean(showThirdPartyModal)) {
      return {
        ...state,
        showThirdPartyModal: showThirdPartyModal
      };
    }
  }

  if (action.type === TARGET_URL) {
    const { targetURL } = action;
    return {
      ...state,
      targetURL: targetURL
    };
  }
  return state;
};
